<section class="header">
  <edge-global-header></edge-global-header>
</section>

<section class="hero">
  <edge-global-hero
    image="/assets/images/football/football-hero.jpg"
    logo="/assets/images/football/edge-football-logo.svg"
    [tagline]="tagline">
    <p>GoArmy Edge Football VR is a free-to-use app for the Meta Quest that brings your existing Edge playbooks into the virtual world.</p>
  </edge-global-hero>
</section>

<section class="content">
  <edge-vr-content></edge-vr-content>
</section>

<section class="headsets">
  <h2>What headsets will GoArmy Edge Football VR run on?</h2>
  <p>GoArmy Edge Football VR will run on the Meta Quest 2, 3, and Pro devices.</p>
</section>

<section class="app-downloads">
  <edge-global-vr-downloads
    sport="Football"
    sportLinkApple="//itunes.apple.com/us/app/goarmy-edge-football/id968154309"
    sportLinkGoogle="//play.google.com/store/apps/details?id=sed.ags.USArmySports.football"
    sportLinkWindows="//www.microsoft.com/en-us/store/p/goarmy-edge-football/9nblggh5xd4p"
    sportLinkWebgl="http://football.goarmyedge.com/webplayer"
    >
  </edge-global-vr-downloads>
</section>

<section class="bottom">
  <edge-global-bottom></edge-global-bottom>
</section>

<section class="footer">
  <edge-global-footer></edge-global-footer>
</section>
